//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'BromageModified_info',
}



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/Anae/Chart_BromageModified_info.vue